import React, { useState, useEffect } from "react";
import { Card, Col, Row, Table, Button } from "react-bootstrap";
import { fetchAPI } from "../utils/fetchAPI";
import { Link } from "react-router-dom";
import { WhiteBoxWrapper } from "./Login.style";
import { getReminderVariant, getDaysLeft } from "../utils/getReminderVariant";
import { FaTrash } from "react-icons/fa";

type Device = {
  id: number;
  name: string;
  description: string;
  avatar: string;
  status: number;
  returnable: number;
  count: number | null;
  note: string | null;
  category: string | null;
};

type Notification = {
  id: number;
  id_user: number;
  id_device: number;
  reminder_date: string;
  description: string;
  device: Device;
};

const NotificationLists = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchNotifications = async () => {
    setIsLoading(true);
    setErrorMessage("");

    try {
      const data = await fetchAPI("GET", "notifications.php");

      if (data.success) {
        setNotifications(data.data);
      } else {
        throw new Error(data.message || "Nie udało się pobrać powiadomień.");
      }
    } catch (error: any) {
      setErrorMessage(error.message || "Wystąpił błąd podczas pobierania danych.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteNotification = async (notificationId: number) => {
    if (!window.confirm("Czy na pewno chcesz usunąć to powiadomienie?")) {
      return;
    }

    try {
      const response = await fetchAPI("POST", "deleteNotification.php", {
        notificationId: notificationId,
      });

      if (response.success) {
        // Odśwież listę powiadomień
        fetchNotifications();
      } else {
        throw new Error(response.message || "Nie udało się usunąć powiadomienia.");
      }
    } catch (error: any) {
      setErrorMessage(error.message || "Wystąpił błąd podczas usuwania powiadomienia.");
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <div>
      <WhiteBoxWrapper>
        <Row className="align-items-center">
          <Col xs={12}>
            <h2 className="text-center">
              <b>Lista powiadomień</b>
            </h2>
          </Col>
        </Row>
      </WhiteBoxWrapper>

      <Card className="p-2 bg-brand-gren">
        {isLoading && <p>Ładowanie danych...</p>}
        {errorMessage && <p className="error">{errorMessage}</p>}

        {!isLoading && !errorMessage && notifications.length > 0 && (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Data</th>
                <th>Opis</th>
                <th>Wyposażenie</th>
                <th>Pozostało</th>
                <th>Akcje</th>
              </tr>
            </thead>
            <tbody>
              {notifications.map((item) => {
                const variant = getReminderVariant(item.reminder_date);
                return (
                  <tr key={item.id} className={`table-${variant}`}>
                    <td>{item.reminder_date}</td>
                    <td>{item.description}</td>
                    <td>
                      {item.device ? <Link to={`/device/${item.device.id}`}>{item.device.name}</Link> : "Brak danych"}
                    </td>
                    <td>{getDaysLeft(item.reminder_date)}</td>
                    <td>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleDeleteNotification(item.id)}
                        title="Usuń powiadomienie"
                      >
                        <FaTrash />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}

        {!isLoading && !errorMessage && notifications.length === 0 && <p>Brak powiadomień do wyświetlenia.</p>}
      </Card>
    </div>
  );
};

export default NotificationLists;
